export const defaultConfig = {
    debug: false,
    dryRun: false,
    events: {
        pageView: true,
        click: true,
        form: false,
        performance: true,
        visibility: true,
        modal: false,
    },
};
